module.exports = __webpack_public_path__ + "static/media/vszathmary.bd04f8f6.jpg";